// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useEffect} from 'react';
import cn from 'classnames';
import {Nav} from './nav';
import {Mobile_nav} from './mobile_nav';
import {use_navbar, use_navbar_props} from './use_navbar';
import styles from './navbar.module.less';

export const Navbar_oculus = (props: use_navbar_props)=>{
    const opt = use_navbar(props);
    useEffect(()=>{
        const update_vh = ()=>{
            document.documentElement.style.setProperty('--vh',
                `${window.innerHeight * 0.01}px`);
        };
        update_vh();
        window.addEventListener('resize', update_vh);
        return ()=>{ window.removeEventListener('resize', update_vh); };
    }, []);
    // XXX dmitriiz: use navbar_global_class only for temporary reason,
    // such as experiments
    const navbar_cls = cn(styles.oculus_navbar, 'navbar_global_class');
    return opt.headless ? <Fragment/> : <div
      className={navbar_cls}>
      <Nav {...opt}/>
      <Mobile_nav {...opt}/>
    </div>;
};
